'use client'

import React from 'react'
import resourcesData from '@/src/components/ExploreResources/resourcesData.json'
import TileSwiper from '@/src/components/commons/generics/TileSwiper/TileSwiper'
import NumberedHeader from '@/src/components/commons/generics/NumberedHeader/NumberedHeader'
import styles from './ExploreResources.module.scss'

const txtNumber = '08'
const txtTitle = 'Explore More Resources'

const ExploreResources: React.FC = () => {
  return (
    <div className={`${styles.exploreResources} w-full bg-white font-dm-mono p-0`}>
      <div className={`${styles.container} max-w-[1440px] my-0 mx-auto relative`}>
        <div
          className={`${styles.titleContainer} mb-[40px] relative flex justify-between items-center`}
        >
          <NumberedHeader
            number={txtNumber}
            title={txtTitle}
            variant="red" //red | gray
            className="mx-auto mb-0!"
          />
        </div>

        <TileSwiper variant="exploreResources" data={resourcesData} />
      </div>
    </div>
  )
}

export default ExploreResources
